module.exports = __webpack_public_path__ + "static/media/gold-drink.29a7ae41.png";